export const SERVER_API_CONTEXT_PATH_PROD = 'https://app.popyouth.ca/pop-server';
export const SERVER_API_CONTEXT_PATH_STAGING = 'https://stg.popyouth.ca/pop-server';
export const SERVER_API_CONTEXT_PATH_DEV = 'https://devpop.ehealthinnovation.org/pop-server';
export const SERVER_API_CONTEXT_PATH_LOCAL = 'http://localhost:8081/pop-server';

export const SERVER_API_CONTEXT_PATH = (stage) => {
  switch (stage) {
    case 'local':
      return SERVER_API_CONTEXT_PATH_LOCAL;
    case 'develop':
      return SERVER_API_CONTEXT_PATH_DEV;
    case 'staging':
      return SERVER_API_CONTEXT_PATH_STAGING;
    case 'prod':
      return SERVER_API_CONTEXT_PATH_PROD;
    default:
      return SERVER_API_CONTEXT_PATH_DEV;
  }
};
